<dx-popup
    [minWidth]="'50%'"
    [minHeight]="'50%'"
    [title]="popUpTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="ap-bill-content">
        <dx-box *ngIf="!!portfolioAssignmentData" width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <cc-data-grid-features
                        [stateConfig]="{
                            storageKey: 'USER_PORTFOLIO_ASSIGNMENT_GRID',
                            storeGroupings: true,
                            storeSortings: true
                        }"
                        [dataSource]="portfolioAssignmentData"
                    >
                        <dx-data-grid
                            width="100%"
                            height="100%"
                            [allowColumnReordering]="true"
                            class="cc-vertical-center-cell-data-grid"
                            [dataSource]="portfolioAssignmentData"
                        >
                            <dxi-column
                                caption="Management Company"
                                dataType="string"
                                dataField="managementCompanyName"
                                [groupIndex]="0"
                            ></dxi-column>
                            <dxi-column caption="Location" dataType="string" dataField="locationName"></dxi-column>
                            <dxi-column
                                caption="Community"
                                dataType="string"
                                dataField="communityName"
                                cellTemplate="communityTemplate"
                            ></dxi-column>
                            <dxi-column
                                caption="Assignment"
                                dataType="string"
                                dataField="businessRoleTitle"
                            ></dxi-column>
                            <dxi-column
                                caption="Is Primary"
                                dataType="boolean"
                                dataField="isPrimary"
                                cellTemplate="booleanCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                caption="Is Backup"
                                dataType="boolean"
                                dataField="isSecondary"
                                cellTemplate="booleanCellTemplate"
                            ></dxi-column>

                            <dxi-column
                                dataField="communityId"
                                dataType="number"
                                [visible]="false"
                                [showInColumnChooser]="false"
                            ></dxi-column>
                            <dxo-summary>
                                <dxi-group-item
                                    column="communityId"
                                    summaryType="count"
                                    displayFormat="Count = {0}"
                                ></dxi-group-item>
                            </dxo-summary>
                            <div *dxTemplate="let row of 'communityTemplate'">
                                <app-property-community-link
                                    *ngIf="!!row.value"
                                    [communityId]="row.data.communityId"
                                    [displayText]="row.value"
                                ></app-property-community-link>
                            </div>
                            <div *dxTemplate="let row of 'booleanCellTemplate'">
                                <i *ngIf="row.value" class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                <i *ngIf="!row.value" class="cc-1-5x cc-icon-cross" [ngClass]="iconClose"></i>
                            </div>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-button
                        type="default"
                        text="Close"
                        hint="Close"
                        [width]="80"
                        [icon]="iconClose"
                        (onClick)="onHidden()"
                    ></dx-button>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
